module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan1-2-24c1da95514dd83855270ad013368bfa.webp";